import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Force scroll to top whenever the location changes
    const scrollToTop = () => {
      // The actual scrollable elements due to the CSS setup
      // Priority order: body and root are the main scrollable containers
      document.body.scrollTop = 0;

      const rootElement = document.getElementById('root');
      if (rootElement) {
        rootElement.scrollTop = 0;
      }

      // Also try these methods as fallbacks
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;

      // Find the main scrollable container if it exists
      const mainContent = document.querySelector('.main-content');
      if (mainContent) {
        mainContent.scrollTop = 0;
      }

      // Also check for the app container
      const appContainer = document.querySelector('.App');
      if (appContainer) {
        appContainer.scrollTop = 0;
      }
    };

    // Execute immediately
    scrollToTop();

    // Also execute after a small delay to ensure DOM is ready
    const timeoutId = setTimeout(scrollToTop, 10);

    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.key]); // Use both pathname and key for better detection

  return null;
};

export default ScrollToTop;